import React from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Post } from '../../types/content';
type PostCardProps = {
  post: Post;
  featured?: boolean;
};
export function PostCard({
  post,
  featured = false
}: PostCardProps) {
  return <article className={featured ? 'grid gap-[clamp(20px,3vw,80px)] md:grid-cols-2 md:items-center' : 'flex h-full flex-col'} data-id="element-41" data-mp="3eywjz0tn2unr">
      <Link to={`/blog/${post.slug}`} className="block aspect-[16/10] overflow-hidden rounded-[18px] border border-ink-line bg-ink-surface" tabIndex={-1} aria-hidden="true" data-id="element-42" data-mp="3j19m7f96gafs">
        <img src={post.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out hover:scale-[1.03]" data-id="element-43" data-mp="3sqktqxgf171k" />
      </Link>
      <div className={featured ? '' : 'mt-5 flex flex-1 flex-col'} data-id="element-44" data-mp="1j8ewp3095ot">
        <time dateTime={post.date} className="font-script text-[clamp(1rem,.5vw+.75rem,1.4rem)] italic text-gold-2" data-id="element-45" data-mp="6k4hmzbmelsn">
          {format(parseISO(post.date), 'MMMM d, yyyy')}
        </time>
        <h3 className={`mt-2 font-slab font-black uppercase leading-[0.95] text-white ${featured ? 'text-[clamp(2.2rem,3vw,5rem)]' : 'text-[clamp(1.5rem,1.2vw+.8rem,2.4rem)]'}`} data-id="element-46" data-mp="1nmpryjblkphe">
          <Link to={`/blog/${post.slug}`} className="hover:text-neon-2" data-id="element-47" data-mp="1do0er3unbt7h">
            {post.title}
          </Link>
        </h3>
        <p className={`mt-3 leading-relaxed text-ink-muted ${featured ? 'text-[clamp(1rem,.4vw+.8rem,1.4rem)]' : 'line-clamp-3 text-sm'}`} data-id="element-48" data-mp="18q8k422m9szl">{post.excerpt}</p>
        <Link to={`/blog/${post.slug}`} className={`${featured ? 'mt-6' : 'mt-auto pt-4'} inline-block font-slab text-sm font-extrabold uppercase tracking-[0.2em] text-neon-2 underline-offset-8 hover:underline`} data-id="element-49" data-mp="21dulr4saanjt">
          Read more
        </Link>
      </div>
    </article>;
}